import i18n from '@/assets/i18n/translate-message';

export const ALLOWED_PERIOD_TYPES = [
  'second',
  'seconds',
  'minute',
  'minutes',
  'hour',
  'hours',
  'day',
  'days',
  'month',
  'months',
];

export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const RANGE_OPTIONS = [
  { text: `${i18n.t('dj-近')}10${i18n.t('dj-分钟')}`, value: 'last-10-minutes', daysAgo: 0.007 },
  { text: `${i18n.t('dj-近')}60${i18n.t('dj-分钟')}`, value: 'last-60-minutes', daysAgo: 0.041 },
  { text: `${i18n.t('dj-近')}3${i18n.t('dj-时')}`, value: 'last-3-hours', daysAgo: 0.125 },
  { text: `${i18n.t('dj-近')}24${i18n.t('dj-时')}`, value: 'last-24-hours', daysAgo: 1 },
  { text: `${i18n.t('dj-近')}3${i18n.t('dj-天')}`, value: 'last-3-days', daysAgo: 3 },
  { text: `${i18n.t('dj-近')}7${i18n.t('dj-天')}`, value: 'last-7-days', daysAgo: 7 },
  { text: `${i18n.t('dj-近')}30${i18n.t('dj-天')}`, value: 'last-30-days', daysAgo: 30 },
  { text: `${i18n.t('dj-近')}3${i18n.t('dj-月')}`, value: 'last-3-months', daysAgo: 90 },
];
